export { default } from './SectionIntegration';